import React, { useState } from 'react';

//imported Comps
import SpecificFeedbackForm from '../Feedback/SpecificFeedbackForm';
import GeneralFeedbackForm from '../Feedback/GeneralFeedbackForm';

function Feedback() {
    const [activeSection, setActiveSection] = useState('menu');

    const changeActiveSection = (section) => {
        setActiveSection(section);
    }

    return (
        <div className="px-3">
            <div className={activeSection === 'menu' ? '' : 'd-none'}>
                <div className="d-flex align-items-start feedback-item" onClick={() => setActiveSection('specific')}>
                    <img src={require("../../images/Feedback/specific-feedback.svg")} alt="section1" />
                    <div className="ml-2">
                        <h3>Specific Feedback</h3>
                        <p className="m-0">I'd like to Give Feedback on a specific part of the page</p>
                    </div>
                </div>
                <div className="d-flex align-items-start feedback-item" onClick={() => setActiveSection('general')}>
                    <img src={require("../../images/Feedback/general-feedback.svg")} alt="section1" />
                    <div className="ml-2">
                        <h3>General Feedback</h3>
                        <p className="m-0">I'd like to Give Feedback on the Site as a Whole</p>
                    </div>
                </div>
                {/* <div className="d-flex align-items-start feedback-item">
                    <img src={require("../../images/Feedback/get-in-touch.svg")} alt="section1" />
                    <div className="ml-2">
                        <h3>Get In Touch (Comimg Soon)</h3>
                        <p className="m-0">I'd like to Give Short Feedback on a specific part of the page</p>
                    </div>
                </div> */}

            </div>

            <div className={activeSection === 'specific' ? '' : 'd-none'}>
                <SpecificFeedbackForm changeActiveSection={changeActiveSection} />

            </div>

            <div className={activeSection === 'general' ? '' : 'd-none'}>
                <GeneralFeedbackForm changeActiveSection={changeActiveSection} />
            </div>
        </div>
    )
}

export default Feedback
